import { Message } from 'element-ui';

export default function message(params) {
  Message({
    offset: 160,
    duration: 4000,
    showClose: true,
    ...formatParams(params)
  });
}

export function messageError(params) {
  message({
    ...formatParams(params),
    type: 'error'
  })
}

export function messageSuccess(params) {
  message({
    ...formatParams(params),
    type: 'success'
  })
}

export function messageWarning(params) {
  message({
    ...formatParams(params),
    type: 'warning'
  })
}

export function messageInfo(params) {
  message({
    ...formatParams(params),
    type: 'info'
  })
}

function formatParams(params) {
  return typeof params === 'string'
    ? {
      message: params,
    }
    : params;
}
